import { getToApi, postToApi } from './axios';

/**
 * Pide al backend una URL presigned PUT para subir una nueva firma a S3.
 * @returns {Promise<{ uploadUrl: string, key: string, expiresAt: string }>}
 */
export const presignSignatureUpload = async () => {
  const response = await postToApi('/signatures/presign-upload', {});
  const data = response.data || response;
  if (data.state !== 'success') {
    throw new Error(data.message || 'Error generando presigned URL');
  }
  return {
    uploadUrl: data.uploadUrl,
    key: data.key,
    expiresAt: data.expiresAt,
  };
};

/**
 * Pide al backend una URL presigned GET para mostrar una firma existente.
 * @param {string} key — S3 key de la firma (formato: signatures/<tenant>/<uuid>.png)
 * @returns {Promise<string>} URL temporal (vence en 1 hora)
 */
export const getSignatureUrl = async (key) => {
  if (!key) throw new Error('getSignatureUrl: key is required');
  const data = await getToApi(`/signatures/url?key=${encodeURIComponent(key)}`);
  if (data.state !== 'success') {
    throw new Error(data.message || 'Error obteniendo URL de firma');
  }
  return data.url;
};

/**
 * Resuelve el `value` de una firma a una URL renderizable por `<Image>`.
 *
 * - Si es una S3 key (`signatures/...`) → pide presigned GET al backend.
 * - Si es un path/URL legacy (pre-migración a S3) → lo devuelve tal cual para
 *   que el <Image> lo resuelva contra el API estático. Esto preserva firmas
 *   viejas hasta que corra la migración de datos (Fase 6 del plan S3).
 * - Si está vacío → null.
 *
 * Pensado para ser llamado en el container del PDF ANTES de generar el
 * documento, no dentro de componentes de `@react-pdf/renderer` (hooks async
 * no funcionan de forma confiable con `pdf().toBlob()`).
 */
export const resolveSignatureUrl = async (value) => {
  if (!value || typeof value !== 'string') return null;
  if (value.startsWith('signatures/')) {
    try {
      return await getSignatureUrl(value);
    } catch (err) {

      return null;
    }
  }
  return value;
};
